import React from 'react'
import Modal from 'react-modal'

const InputModal = (props) => (
    <Modal
        appElement={document.getElementById('app')}
        isOpen={!!props.createLabel}
        onRequestClose={props.clearSelection}
        contentLabel='selectedOption'
        closeTimeoutMS={200}
        className="modal"
    >
        <h3 className="modal__title">{props.message}</h3>
        {props.selectedTitle && <p className="modal__body">{props.selectedTitle}</p>}
        <input type="text" id="new-label" className="modal_input" placeholder="Enter New Label" autoFocus />

        <button className="button" onClick={() => props.confirmAction(document.getElementById("new-label").value)}>Okay</button>&nbsp;&nbsp;
        <button className="button" onClick={props.clearSelection}>Cancel</button>
    </Modal>
)


export default InputModal;


// WEBPACK FOOTER //
// ./src/components/InputModal.js